// extracted by mini-css-extract-plugin
module.exports = {"errorMessage":"convenants_errorMessage__3tDlh","Title":"convenants_Title__2kLtx"};